<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="box_1 flex-col">
        <div class="block_1 flex-row" style="opacity: 0.6; filter: grayscale(50%);">
          <div class="image-text_1 flex-col justify-between">
            <a @click="showComingSoon" style="display: block; text-decoration: none; color: inherit;">
            <img
              class="image_1"
              referrerpolicy="no-referrer"
              src="./assets/img/psujgojvki7qb8er8s4hwi8om3peckzl2v544665dd-b0ae-4564-a017-e07409303564.png"
            />
            <span class="text-group_1">设备报修</span>
            </a>
          </div>
        </div>
        <div class="text-wrapper_1 flex-col"><a href="tel:18836901888" style="text-decoration: none; color: inherit;line-height: 1.4rem;"><span class="text_1">客服热线</span></a></div>
        <div class="block_2 flex-row">
          <div class="image-text_2 flex-col justify-between">
            <img
              class="image_2"
              referrerpolicy="no-referrer"
              src="./assets/img/psy86t8hwqtgcidkrgn1t999hapj8zdbkdhd86bcaee-1972-425c-8692-a594b7b40404.png"
            />
            <div class="text-group_2 flex-col justify-between">
              <span class="text_2">Lianyun&nbsp;Mobile</span>
              <span class="text_3">教育智能伙伴</span>
            </div>
          </div>
        </div>
        <div class="block_3 flex-col">
          <div class="text-wrapper_2 flex-row"><span class="text_4">WWW.10086.SCHOOL</span></div>
          <div class="section_1 flex-row justify-between">
            <div class="box_2 flex-row" style="opacity: 0.6; filter: grayscale(50%);">
              <div class="image-text_3 flex-col justify-between">
                <div style="cursor: pointer; width: 100%; height: 100%;">
                  <a @click="showComingSoon" style="display: block; text-decoration: none; color: inherit;">
                  <img
                    class="image_3"
                    referrerpolicy="no-referrer"
                    src="./assets/img/ps54perxszf9gngq6lctwtifh12oyv84die3ce5350-5449-4258-b640-28ba7d2ced88.png"
                  />
                  <span class="text-group_3">线下营业厅</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="box_3 flex-col justify-between" style="opacity: 0.6; filter: grayscale(50%);">
              <div class="group_2 flex-row">
                <div class="image-text_5 flex-col justify-between">
                  <a @click="showComingSoon" style="display: block; text-decoration: none; color: inherit;">
                    <img
                      class="image_5"
                      referrerpolicy="no-referrer"
                      src="./assets/img/psqtpe24231clrnpw3quljiwoeaoiwlkpeff4bea8-c4b3-404d-8914-4cba22618ecc.png"
                    />
                    <span class="text-group_5">电子商城</span>
                  </a>
                </div>
                
              </div>
              <div class="group_3 flex-row">
                <div class="image-text_4 flex-col justify-between">
                  <!-- <a href="weixin://dl/business/?appid=wx2bfa29ab890777fc&path=pages/home/home&query=&env_version=release" style="display: block; text-decoration: none; color: inherit;"> -->
                  <a @click="showComingSoon" style="display: block; text-decoration: none; color: inherit;">
                  <img
                    class="image_4"
                    referrerpolicy="no-referrer"
                    src="./assets/img/psoccltbm785r2nms44bobj14slpkdz1w92969298b9-99c7-4a1f-9518-d49688b9eb29.png"
                  />
                  <span class="text-group_4">福利专区</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="section_2 flex-col">
            <div class="section_3 flex-col">
              <a href="http://eduform.10086.school/apply" style="display: block; text-decoration: none; color: inherit;">
                <img
                  class="image_6"
                  referrerpolicy="no-referrer"
                  src="./assets/img/psre8b367hyk9ryec6vg3iiprx87pwlmmne114e6e6-4106-42a6-8cfc-2ff7846ba280.png"
                />
                <span class="text_5">教育集群号</span>
              </a>
            </div>
          </div>
        </div>
        <div class="block_4 flex-col" style="opacity: 0.6; filter: grayscale(50%);">
          <a @click="showComingSoon" style="display: block; text-decoration: none; color: inherit;">
          <img
            class="image_7"
            referrerpolicy="no-referrer"
            src="./assets/img/psnp3ww5dog9ew5z5nbte56sn3ehkdrnx2b1d4a04b8-d487-449d-b92c-797764320930.png"
          />
          <span class="text_6">伴学优</span>
          </a>
        </div>
      </div>
      <div class="box_4 flex-col">
        <div style="display: flex; align-items: center; justify-content: center; height: 100%; font-size: 12px; color: #666;"><a href="https://beian.miit.gov.cn/" style="text-decoration: none; color: inherit;">豫ICP备2025155910号-2</a></div>
        <!-- <div class="box_5 flex-row">
          <div class="image-text_6 flex-row justify-between">
            <span class="text-group_6">二七</span>
            <img
              class="thumbnail_1"
              referrerpolicy="no-referrer"
              src="./assets/img/psn82g6scwpeehmk49x9fy8u5csodg87ynsefd81ea3-090b-4f43-9908-45d404a4d3a4.png"
            />
          </div>
          <div class="box_6 flex-row">
            <div class="image-text_7 flex-row justify-between">
              <img
                class="label_1"
                referrerpolicy="no-referrer"
                src="./assets/img/psvijzcssc1saaytpbk7dvaqvz9pq8nq3bdb6e92973-b95f-4373-987a-1db7b47dbbe7.png"
              />
              <span class="text-group_7">想找点什么？</span>
            </div>
          </div>
          <img
            class="label_2"
            referrerpolicy="no-referrer"
            src="./assets/img/ps7lp77b1txgqlzsmjsb29q28z8mxsaus82eafd09-adfc-4bcf-a36b-1a3a61484be4.png"
          />
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {
    showComingSoon() {
      this.$dialog.alert({
        message: '敬请期待…'
      });
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.rem.css" />